import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'payment-info',
    templateUrl: './payment-info.component.html',
    styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
    ways: Way[];

    ngOnInit() {
        let ways = [
            {
                svgSource: '../../assets/electronic-ticket.png',
                name: 'Электронный проездной билет',
                description: ''
            },
            {
                svgSource: '../../assets/bank-card.png',
                name: 'Банковская карта',
                description: ''
            },
            {
                svgSource: '../../assets/cash.png',
                name: 'Наличный расчет',
                description: ''
            },
            {
                svgSource: '../../assets/contactless.png',
                name: 'Бесконтактные системы оплаты',
                description: ''
            }
        ];

        this.ways = ways as Way[];
    }
}

export class Way {
    svgSource: string;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/payment-info.component.ts